<template>
    <v-app-bar id="header_top" :class="{mobile:$vuetify.breakpoint.xs}" :height="60" fixed app dense dark :color="'var(--clr-blue)'">
        <v-toolbar-title 
            v-if="$vuetify.breakpoint.smAndUp || $route.path == '/themes'"        
        >
            <div class="flex-center">
                <div @click="toHome" class="pointer">
                    <img width="50" src="@/assets/images/logo.svg">
                </div>
                <div class="logo clr-white ml-5 pointer" @click="toHome">Tasko</div>
                <button class="button-header px-5 text-capitalize ml-xl-12 ml-lg-12 ml-md-12 ml-sm-6" v-if="!isFeeds" @click="toFeeds()">Лента</button>
                <button class="button-header px-6 text-capitalize ml-xl-12 ml-lg-12 ml-md-12 ml-sm-6" v-else @click="toThemes()">Разделы</button>
                <Search class="ml-6" v-if="$vuetify.breakpoint.smAndUp"/>
            </div>
        </v-toolbar-title>
        <v-row class="pointer" v-if="$vuetify.breakpoint.xsOnly && $route.path != '/themes'">
            <div class="flex-center" @click="toHome">
                <img width="40" src="@/assets/images/logo.svg">
                <div class="logo mobile clr-black-38 clr-white ml-5">Tasko</div>
            </div>
        </v-row>
        <v-spacer v-else></v-spacer>
        <ToolbarItems/>
    </v-app-bar>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import ToolbarItems from './ToolbarItems'
    import Search from './Search'
    export default {
        name: 'HeaderTop',
        data() {
            return {

            }
        },  
        components: {
            ToolbarItems,
            Search
        },  
        computed:{
            ...mapGetters(['current', 'current_feed', 'feeds', 'themes', 'language', 'user']),             
            themes_select(){
              return this.themes.map(el => el.name)
            },
            feeds_select(){
              return this.feeds.map(el => el.name)
            },
            isFeeds() {
                return !this.$route.path.indexOf('/feeds')
            }
        },
        methods:{
            selectThemeMobile(name){
                const theme = this.themes.filter(el => el.name == name)[0]
                this.SET_CURRENT(theme)
                this.$router.push("/theme/" + theme.route_name)
            },  
            selectFeedMobile(name){
                const feed = this.feeds.filter(el => el.name == name)[0]
                this.SET_CURRENT_FEED(feed)
                this.$router.push("/feed/" + feed.route_name)
            },  
            toHome(){
                this.$root.$emit('toHome')
                this.$router.push('/')
                this.SET_CURRENT(this.themes[0])
            },
            toFeeds() {
                this.$router.push('/feeds')
                if(!this.feeds.length) {
                    this.addFeed({name: "Default", body: ""})
                } 
            },
            toThemes() {
                this.$router.push('/theme')
            },
            ...mapActions([
                'logOut', 'setLanguage', 'setTheme', 'addFeed'
            ]),
            ...mapMutations(['OPEN_POPUP', 'SET_CURRENT', 'SET_CURRENT_FEED'])
        }
    }
</script>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css?family=Rambla&display=swap');
    #header_top{
        position: relative;
    }
    .logo{
        font-family: Questrial;
        font-weight: 100;
        margin-top: 3px;
        font-size: 38px;
        &.mobile {
            font-size: 28px;
        }
    }
    #header_top.theme--light{
        // background: var(--cl-primary);
        box-shadow: none;
        color: white;
    }
    .logo{
        font-family: 'Rambla', sans-serif;
    }
    .theme--dark.v-app-bar.v-toolbar.v-sheet {
        box-shadow: none;
    }
</style>

<style lang="scss">
    .select_theme .v-label--active{
        display: none !important; 
    }
    #header_top .v-toolbar__content{
        padding: 31px 0 31px 51px !important;
    }    
    #header_top.mobile{
        .v-toolbar__content{
            padding-right: 16px !important;
        }    
        .feeds-col{
            &.col-1{
                padding-left: 24px !important;
                padding-right: 20px !important;
            }
            &.col-10{
                padding-right: 5px;
                .select_feed{
                    height: 100%;
                    > .v-input__control{
                        height: 100%;
                        justify-content: center;
                    }
                }
            }
        }
        .themes-col{
            &.col-10{
                padding-right: 0 !important;
                .select_theme{
                    height: 100%;
                    > .v-input__control{
                        height: 100%;
                        justify-content: center;
                    }
                }                
            }            
        }   
        .v-text-field__details{
            display: none !important;
        }             
    }
</style>